import HttpClient from "application/services/http-client";
import { IApplicationData } from "models/application-data";
import { IGetEntityByMunicipalPortalRequest } from "models/request/entity-by-municipal-portal-request";

const defaultPath = 'Base';

const requestApplicationData = async (): Promise<IApplicationData> => {

    var url = window.location.hostname;
    var multitennantId = 1;

    if (url.includes("localhost")) {
        // url = "buerarema.ba.gov.br";
        // url = "cmcoracaodemaria-ba.munidados.com.br";
        //url = "pmjussiape-ba-dev.munidados.com.br/";
        url = "cmirece-ba-dev.publidocs.com.br/";
    }

    var request = { url } as IGetEntityByMunicipalPortalRequest;

    var applicationData = await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${multitennantId}`,
        params: request
    }).then((response) => Object.assign({} as IApplicationData, response.data));

    setApplicationData(applicationData);

    return applicationData;
};

const getApplicationData = (): IApplicationData | undefined => {
    let value = localStorage.getItem("application_data") as string;
    if (value != null && value != undefined) {
        return JSON.parse(value);
    } else {
        return undefined;
    }
};

const setApplicationData = (data: IApplicationData) => {
    const application = Object.assign({} as IApplicationData, data)
    localStorage.setItem("application_data", JSON.stringify(application));
};

const clearApplicationData = () => {
    localStorage.removeItem("application_data");
};

const BaseAppService = {
    requestApplicationData, clearApplicationData, getApplicationData, setApplicationData
};

export default BaseAppService;